import * as React from 'react';
import {TextArea} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

export const DisabledReadOnly = () => (
  <div>
    <div style={{padding: '20px 0'}}>
      <TextArea label="Disabled" defaultValue={EXAMPLE_TEXT} disabled />
    </div>
    <div style={{padding: '20px 0'}}>
      <TextArea label="Readonly" defaultValue={EXAMPLE_TEXT} readOnly />
    </div>
  </div>
);
